import React, { CSSProperties } from "react";

interface OptionsCardProps {
  img: string;
  alt?: string;
  title?: string;
  style?: CSSProperties;
  subTitle?: string;
  link?: string;
}

const OptionsCard = (props: OptionsCardProps) => {
  const { img, alt = "image", title, subTitle, link = "/", ...rest } = props;
  return (
    <a href={link}>
      <div
        {...rest}
        className="relative h-[10rem] lg:h-[17rem] w-full bg-[#123123] rounded-[20px] flex flex-col justify-center items-center text-center cursor-pointer"
      >
        <div className="absolute opacity-10 w-[35%]">
          <img className="h-full w-full object-contain" alt={alt} src={img} />
        </div>
        <h2 className="font-bold text-[2rem] lg:text-[3rem] mb-2">{title}</h2>
        <h2 className="font-semibold text-[1rem] lg:text-[1.5rem]">
          {subTitle}
        </h2>
      </div>
    </a>
  );
};

export default OptionsCard;
